module.exports = __webpack_public_path__ + "media/images/flags/32/Mexico-6ed66565aa7506357b023c3ad16b1c56.png";